import { useState } from 'react';

const useCustomHook = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState(false);
  const [cancelingRequest, setCancelingRequest] = useState(false);

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [selectedRowToDelete, setSelectedRowToDelete] = useState(null);

  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);




  
  return {
    activeTab,
    setActiveTab,
    loading,
    setLoading,
    cancelingRequest,
    setCancelingRequest,
    isConfirmOpen,
    setIsConfirmOpen,
    selectedRowToDelete,
    setSelectedRowToDelete,
    filterParams,
    setFilterParams,
    size,
    setSize,
  };
};

export default useCustomHook;
